import * as THREE from 'three';

/** Brand colours from the booth rendering. */
export const BRAND = {
  navy: '#1b2440',
  red: '#e63946',
  white: '#ffffff',
  offWhite: '#f3f4f7',
  ink: '#15192b',
  grey: '#8a90a3',
  screenBg: '#0e1530',
} as const;

export const FONT = {
  display: '700 {size}px "Helvetica Neue", Helvetica, Arial, sans-serif',
  body: '500 {size}px "Helvetica Neue", Helvetica, Arial, sans-serif',
  mono: '500 {size}px Menlo, Consolas, monospace',
} as const;

export function font(kind: keyof typeof FONT, size: number): string {
  return FONT[kind].replace('{size}', String(size));
}

export function makeCanvas(
  width: number,
  height: number,
): CanvasRenderingContext2D {
  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;
  const ctx = canvas.getContext('2d');
  if (!ctx) throw new Error('2D canvas is not available');
  return ctx;
}

export function makeTexture(
  ctx: CanvasRenderingContext2D,
): THREE.CanvasTexture {
  const tex = new THREE.CanvasTexture(ctx.canvas);
  tex.colorSpace = THREE.SRGBColorSpace;
  tex.anisotropy = 8;
  return tex;
}

/** Draws `lines` top-aligned at (x, y) with the given line height. */
export function drawLines(
  ctx: CanvasRenderingContext2D,
  lines: ReadonlyArray<{ text: string; color: string; font: string }>,
  x: number,
  y: number,
  lineHeight: number,
  align: CanvasTextAlign = 'left',
): number {
  ctx.textAlign = align;
  ctx.textBaseline = 'top';
  let cursor = y;
  for (const line of lines) {
    ctx.font = line.font;
    ctx.fillStyle = line.color;
    ctx.fillText(line.text, x, cursor);
    cursor += lineHeight;
  }
  return cursor;
}

export function roundRect(
  ctx: CanvasRenderingContext2D,
  x: number,
  y: number,
  w: number,
  h: number,
  r: number,
): void {
  ctx.beginPath();
  ctx.moveTo(x + r, y);
  ctx.arcTo(x + w, y, x + w, y + h, r);
  ctx.arcTo(x + w, y + h, x, y + h, r);
  ctx.arcTo(x, y + h, x, y, r);
  ctx.arcTo(x, y, x + w, y, r);
  ctx.closePath();
}
